module.exports = __webpack_public_path__ + "img/task.86e6d182.svg";